import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

// One line of a field row. The grip, the checkbox and the name all take this height, so a field with settings of
// its own (the annual wheel's timeline) keeps its first line level with the grip while its settings open beneath.
export const fieldLineHeight = 40;
const gripWidth = 24;

export const useTableDisplayFieldsPaneStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        sectionHeading: {
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            marginBottom: 1,
            fontSize: theme.typography.pxToRem(12),
            fontWeight: 600,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        sectionHint: {
            fontWeight: 400,
            textTransform: "none",
            letterSpacing: 0,
            color: theme.palette.grey[600],
        },
        groupHeading: {
            marginTop: 1.5,
            paddingLeft: `${gripWidth}px`,
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.grey[600],
        },
        hiddenSection: {
            marginTop: 2,
            paddingTop: 2,
            borderTop: `1px solid ${theme.palette.grey[200]}`,
        },
        fieldRow: {
            display: "flex",
            alignItems: "flex-start",
            borderRadius: 1,
            backgroundColor: theme.customPalette.white,
            "&:hover": {
                backgroundColor: theme.palette.grey[50],
            },
        },
        draggingFieldRow: {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
        },
        grip: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: gripWidth,
            height: fieldLineHeight,
            color: theme.palette.grey[500],
            cursor: "grab",
        },
        gripSpace: {
            flexShrink: 0,
            width: gripWidth,
        },
        fieldLine: {
            display: "flex",
            alignItems: "center",
            minHeight: fieldLineHeight,
        },
        fieldContent: {
            flex: 1,
            minWidth: 0,
        },
        labelledFieldLine: {
            flex: 1,
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            minHeight: fieldLineHeight,
        },
        alwaysShown: {
            display: "flex",
            alignItems: "center",
            height: fieldLineHeight,
            paddingRight: 1,
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.grey[600],
            whiteSpace: "nowrap",
        },
    });
};
